import React from "react";
import { Button } from "../../../../components/Button";
import { Icon } from "../../../../components/core/Icon";
import { Steps } from "../../../../components/Steps";
import { ProductNameAndImageStep } from "./Steps/ProductNameAndImageStep";
import { ProductDrinkSizes } from "./Steps/ProductDrinkSizes";

import styles from "../../../../../styles/add-product.module.scss";
import { ProductAvailabilityStep } from "./Steps/ProductAvailabilityStep";
import { Availability } from "../../../../utils/Availability";


const StepNames = {
    NAME_AND_IMAGE: 'NAME_AND_IMAGE',
    SIZES: 'SIZES',
    EXTRA_INGREDIENTS: 'EXTRA_INGREDIENTS',
    AVAILABILITY: 'AVAILABILITY'
}

export class ProductDrink extends React.Component {

    state = {
        product: {
            type: 'drink',
            name: null,
            show: true,
            highlight: false,
            availability: null,
            extra_ingredients: [],
            items: [],
            sizes: [],
        },
        steps: 3,
        step: StepNames.NAME_AND_IMAGE,
        currentStep: 1,
        disabled: true
    }

    componentDidMount() {
        const { product: stateProduct } = this.state;
        const { product, category } = this.props;
        this.setState({ 
            product: { 
                ...stateProduct,
                ...product, 
                parent: category.id 
            } 
        });
    }

    onChangeProduct(values) {
        const { product } = this.state;
        this.setState({ product: { ...product, ...values } }, this.validateStep.bind(this));
    }

    validateStep() {
        const { step, product } = this.state;
        switch (step) {
            case StepNames.NAME_AND_IMAGE:
                return this.setState({ disabled: !product || !product.name });
            case StepNames.SIZES:
                return this.setState({
                    disabled: product.sizes.reduce((f, size) => (f || (!size.package || !size.unit || !size.amount || !size.price)), false)
                })
            // case StepNames.EXTRA_INGREDIENTS:
            //     return this.setState({
            //         disabled: (
            //             product.extra_ingredients.length > 0
            //             && !(product.extra_ingredients.reduce((previousExtra, extra) => {
            //                 return previousExtra && !!extra.name && extra.sizes.reduce((previousExtraSize, extraSize) => {
            //                     return previousExtraSize && !!extraSize.name && !!extraSize.price && Number(String(extraSize.price)) != NaN
            //                 }, true)
            //             }, true))
            //         )
            //     })
            case StepNames.AVAILABILITY:
                return this.setState({
					disabled: Availability.hasIncompleteAvailability(product.availability)
                });
            default:
                return null;
        }
    }

    nextStep() {
        const { step, product } = this.state;
        const { category } = this.props;

        switch (step) {
            case StepNames.NAME_AND_IMAGE:
                return this.setState({
                    step: StepNames.SIZES,
                    currentStep: 2,
                    disabled: true
                }, this.validateStep.bind(this));
            case StepNames.SIZES:
                return this.setState({
                    step: StepNames.AVAILABILITY,
                    currentStep: 3,
                    disabled: true
                }, this.validateStep.bind(this));
            // case StepNames.EXTRA_INGREDIENTS:
            //     return this.setState({
            //         step: StepNames.AVAILABILITY,
            //         currentStep: 5,
            //         disabled: true
            //     }, this.validateStep.bind(this));
            case StepNames.AVAILABILITY:
                return false;
        }
    }

    prevStep() {
        const { step, product } = this.state;
        const { category, onPrev } = this.props;

        switch (step) {
            case StepNames.SIZES:
                return this.setState({
                    step: StepNames.NAME_AND_IMAGE,
                    currentStep: 1,
                    disabled: false
                }, this.validateStep.bind(this));
            case StepNames.EXTRA_INGREDIENTS:
                //Se não tiver tamanhos padrões, voltar para a seleção de tamanhos padrões
                return this.setState({
                    step: category.default_sizes === false ? StepNames.DEFAULT_SIZES : StepNames.SIZES,
                    currentStep: category.default_sizes === false ? 2 : 3,
                    disabled: false
                }, this.validateStep.bind(this));
            case StepNames.AVAILABILITY:
                return this.setState({
                    step: category.default_sizes === false ? StepNames.DEFAULT_SIZES : StepNames.EXTRA_INGREDIENTS,
                    currentStep: category.default_sizes === false ? 2 : 4,
                    disabled: false
                }, this.validateStep.bind(this));

        }
    }

    onSave () {
        const { onSave } = this.props;
        const { product } = this.state;

        product.availability = Availability.getValidAvailability(product.availability);

        onSave && onSave(product);
    }

    render() {
        const { category } = this.props;
        const { product, currentStep, step, steps, disabled } = this.state;

        return (
            <>
                <Steps steps={steps} currentStep={currentStep} />
                <div className={styles.scrollContainer}>
                    {step == StepNames.NAME_AND_IMAGE && (<ProductNameAndImageStep product={product} onChange={this.onChangeProduct.bind(this)} />)}
                    {step == StepNames.SIZES && (<ProductDrinkSizes category={category} product={product} onChange={this.onChangeProduct.bind(this)} />)}
                    {step == StepNames.AVAILABILITY && (<ProductAvailabilityStep item={product} onChange={this.onChangeProduct.bind(this)} />)}
                </div>
                <div className={`${styles.footer} ${step != StepNames.NAME_AND_IMAGE ? "justify-between" : "justify-end"}`}>
                    {step !== StepNames.NAME_AND_IMAGE && (
                        <Button design="default-icon" onClick={this.prevStep.bind(this)}>
                            <Icon name="long-arrow-left" size="xl" />
                        </Button>
                    )}
                    {step === StepNames.AVAILABILITY ? (
                        <Button design="primary-icon" onClick={this.onSave.bind(this)} disabled={disabled}>
                            <Icon name="check" size="xl" />
                        </Button>
                    ) : (
                        <Button design="primary-icon" onClick={this.nextStep.bind(this)} disabled={disabled}>
                            <Icon name="long-arrow-right" size="xl" />
                        </Button>
                    )}
                </div>
            </>
        );
    }
}